import { FilterDefinition } from 'src/app/paginated-table/filter-panel/filter-panel.component';

const VISIBLE_DOMAIN_STATES = [
  { label: $localize`:filters|state values:Registration pending`, value: 'registration_pending' },
  { label: $localize`:filters|state values:Active`, value: 'active' },
  { label: $localize`:filters|state values:Admonition`, value: 'admonition' },
  { label: $localize`:filters|state values:Purchase`, value: 'purchase' },
  { label: $localize`:filters|state values:Snapback`, value: 'snapback' },
  { label: $localize`:filters|state values:Takedown`, value: 'takedown' },
  { label: $localize`:filters|state values:UDRP`, value: 'udrp' },
  { label: $localize`:filters|state values:Transfer pending`, value: 'transfer_pending' },
  { label: $localize`:filters|state values:Transfer out pending`, value: 'transfer_out_pending' },
  { label: $localize`:filters|state values:Expired`, value: 'expired' },
  { label: $localize`:filters|state values:Deletion pending`, value: 'deletion_pending' },
  { label: $localize`:filters|state values:External`, value: 'external' },
  { label: $localize`:filters|state values:Preordered`, value: 'preordered' },
  { label: $localize`:filters|state values:Hold`, value: 'hold' },
  { label: $localize`:filters|state values:Deleted`, value: 'deleted' },
  { label: $localize`:filters|state values:EOI`, value: 'eoi' },
  { label: $localize`:filters|state values:Transfer cancelled`, value: 'transfer_cancelled' },
  { label: $localize`:filters|state values:Registration cancelled`, value: 'registration_cancelled' },
  { label: $localize`:filters|state values:Preorder cancelled`, value: 'preorder_cancelled' }
]

export const FILTER_DEFINITIONS: FilterDefinition[] = [
  {
    label: $localize`:filters|Filter name:Domain name`,
    operators: [
      { label: $localize`:filters|Operator name:matches any`, inputType: 'text', operator: 'idnOrPunycodeMatchAny', field: 'name' },
      { label: $localize`:filters|Operator name:does not match any`, inputType: 'text', operator: 'idnAndPunycodeDoNotMatchAny', field: 'name' },
      { label: $localize`:filters|Operator name:equals any`, inputType: 'text', operator: 'idnOrPunycodeEqualAny', field: 'name' },
      { label: $localize`:filters|Operator name:does not equal any`, inputType: 'text', operator: 'idnAndPunycodeDoNotEqualAny', field: 'name' }
    ]
  },
  {
    label: $localize`:filters|Filter name:TLD`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'tld_name' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'tld_name' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Brand`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'brand_name' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'brand_name' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Division`,
    operators: [
      { label: $localize`:filters|Operator name:contains`, inputType: 'text', operator: 'contains', field: 'department_name' },
      { label: $localize`:filters|Operator name:contains not`, inputType: 'text', operator: 'containsNot', field: 'department_name' }
    ]
  },
  {
    label: $localize`:filters|Filter name:Status`,
    operators: [
      { label: $localize`:filters|Operator name:is`, inputType: 'multiselect', operator: 'withVisibleStates', possibleValues: VISIBLE_DOMAIN_STATES },
      { label: $localize`:filters|Operator name:is not`, inputType: 'multiselect', operator: 'withoutVisibleStates', possibleValues: VISIBLE_DOMAIN_STATES }
    ]
  },
]
